var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23032 11.2149C8.30197 11.2897 8.39882 11.3318 8.49984 11.332C8.60086 11.3318 8.6977 11.2897 8.76935 11.2149L13.7215 6.01516C13.793 5.94011 13.8332 5.83833 13.8332 5.7322C13.8332 5.62607 13.793 5.52428 13.7215 5.44924C13.6501 5.37419 13.5531 5.33203 13.452 5.33203H3.54766C3.44657 5.33203 3.34962 5.37419 3.27814 5.44924C3.20666 5.52428 3.1665 5.62607 3.1665 5.7322C3.1665 5.83833 3.20666 5.94011 3.27814 6.01516L8.23032 11.2149Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUser);
export default __webpack_public_path__ + "static/media/arrow-user.795eb60e1082037791528c4c8d844921.svg";
export { ForwardRef as ReactComponent };